module.exports = __webpack_public_path__ + "img/photo_ph_2.f65c865c.png";